import React, { useState, useMemo } from "react";
import { Box, Collapse } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { MaterialTableLineItems } from "./MaterialTableLineItems";
import { sortPosition, fmtINR } from "../../../../util/helper";
import classNames from "classnames";
import { Button } from "react-bootstrap";
import { exitSelectedPositionsAction } from "../../../../redux/actions/packageAction";

const SubGroupRow = ({
  subGroup,
  columns,
  isBasketAdded,
  source,
  info,
  inputValues,
  buySellClick,
  updateBasket,
  handleChange,
  checkedId,
  isClosedPosition,
  isDark,
  groupingMode,
  parentKey
}) => {
  const [open, setOpen] = useState(true);

  // Generate unique ID for DOM updates - sanitize spaces and slashes
  const currentKey = String(groupingMode).replace(/[^a-zA-Z0-9]/g, '') + "-" + String(subGroup.name).replace(/[^a-zA-Z0-9]/g, '');
  const groupKey = (parentKey ? parentKey + "-" : "") + currentKey;

  const hasPositions = useMemo(() => {
    const openPositions = subGroup.data.filter((p) => p.netQuantity !== 0);
    const ce = openPositions.some((p) => p.instrument?.instrumentType === "CE");
    const pe = openPositions.some((p) => p.instrument?.instrumentType === "PE");
    const any = openPositions.length > 0;
    const selected = openPositions.some(p => checkedId?.includes(p.id));
    return { ce, pe, any, selected };
  }, [subGroup.data, checkedId]);

  const handleExitCE = (e) => {
    e.stopPropagation();
    const positionIds = subGroup.data
      .filter(pos => pos.netQuantity !== 0 && pos.instrument?.instrumentType === "CE")
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitPE = (e) => {
    e.stopPropagation();
    const positionIds = subGroup.data
      .filter(pos => pos.netQuantity !== 0 && pos.instrument?.instrumentType === "PE")
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitAll = (e) => {
    e.stopPropagation();
    const positionIds = subGroup.data
      .filter(pos => pos.netQuantity !== 0)
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitSelected = (e) => {
    e.stopPropagation();
    const positionIds = subGroup.data
      .filter(pos => pos.netQuantity !== 0 && checkedId?.includes(pos.id))
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };


  return (
    <div className="sub-group-wrapper">
      <div className="sub-group-header d-flex align-items-center" onClick={() => setOpen(!open)}>
        <div className="d-flex align-items-center">
          <button
            aria-label="expand sub-row"
            style={{
              background: "none",
              border: "none",
              padding: "2px 4px",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: isDark ? "#afb2b6" : "#000", fontSize: "18px" }} />
            ) : (
              <KeyboardArrowRightIcon style={{ color: isDark ? "#afb2b6" : "#000", fontSize: "18px" }} />
            )}
          </button>

          <span className="sub-group-label">{subGroup.name}</span>
          <span 
            id={"group-count-" + groupKey}
            className="ms-2" 
            style={{ fontSize: "11px", opacity: 0.6, color: isDark ? "#afb2b6" : "#4b5563" }}
          >
            ({subGroup.data.filter((i) => i.netQuantity !== 0).length}/{subGroup.data.length})
          </span>
        </div>

        <div className="d-flex align-items-center gap-3 ms-4 me-3">
          <div className="single-leg-pnl d-flex align-items-center m-0">
             <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Total:</span>
             <span
               id={"group-pnl-" + groupKey}
               className={`ms-1 ${subGroup.totalPNL === 0 ? "" : subGroup.totalPNL > 0 ? "text-success" : "text-danger"}`}
               style={{ fontWeight: 600, fontSize: "12px" }}
             >
               {fmtINR(subGroup.totalPNL)}
             </span>
          </div>

          <div className="single-leg-pnl d-flex align-items-center m-0">
             <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Unrealized:</span>
             <span
               id={"group-u-" + groupKey}
               className={`ms-1 ${subGroup.tolUnrealizedPNL === 0 ? "" : subGroup.tolUnrealizedPNL > 0 ? "text-success" : "text-danger"}`}
               style={{ fontSize: "11px" }}
             >
               {fmtINR(subGroup.tolUnrealizedPNL)}
             </span>
          </div>

          <div className="single-leg-pnl d-flex align-items-center m-0">
             <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Realized:</span>
             <span
               id={"group-r-" + groupKey}
               className={`ms-1 ${subGroup.totaLrealizedPNL === 0 ? "" : subGroup.totaLrealizedPNL > 0 ? "text-success" : "text-danger"}`}
               style={{ fontSize: "11px" }}
             >
               {fmtINR(subGroup.totaLrealizedPNL)}
             </span>
          </div>

          <div className="d-flex btn-exit ms-2 gap-1" style={{ width: hasPositions.selected ? "280px" : "200px" }}>
            <Button
              disabled={!hasPositions.ce}
              onClick={handleExitCE}
              className="text-primary"
              size="sm"
              variant="outline-primary"
              style={{ padding: '0px 6px', fontSize: '10px' }}
            >
              Exit CE
            </Button>
            <Button
              disabled={!hasPositions.pe}
              onClick={handleExitPE}
              className="text-warning"
              size="sm"
              variant="outline-warning"
              style={{ padding: '0px 6px', fontSize: '10px' }}
            >
              Exit PE
            </Button>
            <Button
              disabled={!hasPositions.any}
              onClick={handleExitAll}
              className="text-danger"
              size="sm"
              variant="outline-danger"
              style={{ padding: '0px 6px', fontSize: '10px' }}
            >
              Exit All
            </Button>
            {hasPositions.selected && (
              <Button
                onClick={handleExitSelected}
                className="text-danger"
                size="sm"
                variant="outline-danger"
                style={{ padding: '0px 6px', fontSize: '10px', width: "75px" }}
              >
                Exit Selected
              </Button>
            )}
          </div>
        </div>
      </div>


      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box className="basket-items sub-group-items">
          <MaterialTableLineItems
            basketId={"undefined"}
            lineItems={sortPosition(subGroup.data, isClosedPosition)}
            columns={columns}
            isBasketAdded={isBasketAdded}
            source={source}
            info={info}
            inputValues={inputValues}
            buySellClick={buySellClick}
            updateBasket={updateBasket}
            handleChange={handleChange}
            checkedId={checkedId}
            isSingleLeg={true}
            isDark={isDark}
          />
        </Box>
      </Collapse>
    </div>
  );
};

export default SubGroupRow;
